ALLOWED_CONTROLLER = 'gateway_node_table_statuses'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  $('#gateway_node_table_statuses').dataTable
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    iDisplayLength: 50
    sAjaxSource: $('#gateway_node_table_statuses').data('source')
    order: [ [ 0, "desc" ] ]
    aoColumnDefs:
      [ { 'bSortable': false, 'aTargets': [ 4, 5 ] } ]
    initComplete: ->
      this.api().columns('.select-filter').every( -> #https://datatables.net/reference/api/columns().every()
        column = this
        select = $('<select><option value="">all</option></select>')
        select.appendTo( $(column.footer()).empty() )
        select.append( '<option value="yes">yes</option>' )
        select.append( '<option value="no">no</option>' )
        select.on( 'change', ->
          val = $.fn.dataTable.util.escapeRegex($(this).val())
          console.log(val)
          column.search( val ? '^' + val + '$' : '', true, false ).draw()
        )
      )
    fnServerData: _.debounce((sSource, aoData, fnCallback, oSettings) ->
      $.ajax
        dataType: 'json'
        type: 'GET'
        url: sSource
        data: aoData
        success: fnCallback
    , 1200)

$(document).ready(ready)
